<template>
  <b-row>
    <b-col>
      <b-row class="profile-row" v-if="isLoading">
        <b-col class="d-flex justify-content-center align-items-center" style="min-height: 100px">
          <b-spinner label="Carregando..."></b-spinner>
        </b-col>
      </b-row>
      <b-row class="profile-row" v-else>
        <b-col>
          <img
            v-if="!studentPhoto"
            src="@/assets/images/default-photo.png"
            height="64"
            width="64"
            alt="Foto padrão"
          />
          <img
            v-else
            width="64"
            height="64"
            :src="studentPhoto"
            alt="Foto do estudante"
          />

          <div class="content-meeting" style="justify-content: space-between">
            <div class="column">
              <h5>{{ studentName }}</h5>
              <p>
                <strong>Área do Conhecimento:</strong>
                {{ subject && subject.designation ? subject.designation : "" }}
              </p>
            </div>

            <div class="column two">
              <p>
                <strong>Ciclo:</strong>
                {{ cycle && cycle.designation ? cycle.designation : "" }}
                ({{ cycleYear }} º ano no ciclo)
              </p>
              <p>
                <strong>Evolução em relação ao currículo:</strong>
                <span class="learning-progress">
                  {{ formattedPercentage }}%
                  <b-progress
                    :value="subjectPercentage"
                    class="white"
                  ></b-progress>
                </span>
              </p>
            </div>
          </div>
        </b-col>

        <b-col>
          <div class="content-meeting" v-if="!isParentOrStudent">
            <div class="column" style="padding-top: 30px">
              <p><strong>Legenda:</strong></p>
              <p><strong>EE:</strong> Conteúdo em estudo</p>
              <p><strong>A:</strong> Conteúdo aprendido</p>
              <p><strong>AN:</strong> Conteúdo ainda não aprendido</p>
              <p>
                <strong>*:</strong> Conteúdo supostamente aprendido em outro
                estabelecimento de ensino
              </p>
              <p><strong>#:</strong> Dispensa de conteúdo curricular</p>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "LearningRecordHeader",
  props: {
    studentPhoto: {
      type: String,
      default: null,
    },
    studentName: {
      type: String,
      required: true,
    },
    subject: {
      type: Object,
      default: () => ({}),
    },
    cycle: {
      type: Object,
      default: () => ({}),
    },
    cycleYear: {
      type: [String, Number],
      default: "",
    },
  },
  computed: {
    ...mapGetters({
      user: "auth/getAuthData",
    }),
    isLoading() {
      return !this.studentName;
    },
    subjectPercentage() {
      return this.subject && this.subject.percentage
        ? Number(this.subject.percentage).toFixed(0)
        : 0;
    },
    formattedPercentage() {
      return this.subjectPercentage || "";
    },
    isParentOrStudent() {
      return this.user && (this.user.role.includes("parent") || this.user.role.includes("student"));
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/variables.scss";

.profile-row {
  background: -webkit-linear-gradient(left, #36b67d, #6883c5);
  border-radius: 10px;
  color: #fff;
  margin: 30px 0 60px;
  padding: 28px 10px;
  position: relative;

  &:after {
    right: 0;
    pointer-events: none;
    position: absolute;
    top: -5px;
  }

  .col {
    display: flex;
    align-items: center;

    img {
      margin-right: 40px;
    }

    .content-meeting {
      display: flex;
      width: 100%;
      text-align: left;
      .column {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        min-height: 60px;
        min-width: 250px;
        margin-right: 30px;

        &.two {
          min-width: 650px;
        }

        .learning-progress {
          display: inline-flex;
          align-items: center;
          margin-left: 10px;
          width: 50%;

          .progress {
            width: 100%;
            margin-left: 15px;

            &.white {
              background-color: transparent;
              border: 1px solid $white;

              .progress-bar {
                background-color: $white;
              }
            }
          }
        }
      }

      h5 {
        margin: 0;
      }

      p {
        margin: 0;
      }
    }
  }
}

.progress {
  border-radius: 30px;
  height: 7px;

  .progress-bar {
    background-color: $purple;
  }
}
</style>
